module.exports = __webpack_public_path__ + "img/couples-044.3d58c5f2.jpg";